import { useTranslation } from 'react-i18next';

import { SearchInput } from '@amzn/storm-ui';

import {
    SearchContainer, SuggestionItem, SuggestionMeta, SuggestionsContainer, SuggestionText
} from './EnhancedSearchInput.styles';
import { useEnhancedSearch } from './hooks/useEnhancedSearch';
import { EnhancedSearchInputProps } from './interfaces/EnhancedSearchInterface';

export const EnhancedSearchInput = (props: EnhancedSearchInputProps) => {
  const {
    containerRef,
    inputValue,
    handleInputChange,
    handleInputFocus,
    handleKeyDown,
    handleClear,
    showSuggestions,
    filteredSuggestions,
    highlightedIndex,
    handleSuggestionClick,
  } = useEnhancedSearch(props);
  const { t } = useTranslation();
  const { placeholder, id } = props;

  return (
    <SearchContainer ref={containerRef}>
      <SearchInput
        id={id}
        placeholder={
          placeholder || t('search-booking-placeholder', 'Search bookings...')
        }
        value={inputValue}
        onChange={({ target }) => handleInputChange(target.value)}
        onFocus={handleInputFocus}
        onKeyDown={handleKeyDown}
        onClear={handleClear}
      />
      <SuggestionsContainer
        show={showSuggestions && filteredSuggestions.length > 0}
      >
        {filteredSuggestions.map((suggestion, index) => (
          <SuggestionItem
            key={`${suggestion.field}-${suggestion.value}-${index}`}
            highlighted={index === highlightedIndex}
            onClick={() => handleSuggestionClick(suggestion)}
          >
            <SuggestionText>{suggestion.value}</SuggestionText>
            {suggestion.meta && (
              <SuggestionMeta>{suggestion.meta}</SuggestionMeta>
            )}
          </SuggestionItem>
        ))}
      </SuggestionsContainer>
    </SearchContainer>
  );
};
